// ============================================================================
//  BrandMark.tsx — Logo NexusCorp réutilisable
//  Carré arrondi violet (charte) avec le « N » stylisé. Blanc sur violet
//  (contraste WCAG AA OK). Taille paramétrable.
// ============================================================================

export function BrandMark({ size = 34, radius = 10 }: { size?: number; radius?: number }) {
  return (
    <div
      className="shrink-0 flex items-center justify-center relative overflow-hidden"
      style={{
        width: size,
        height: size,
        borderRadius: radius,
        background: 'linear-gradient(135deg, #7C3AED 0%, #4B0082 100%)',
        boxShadow: '0 3px 12px rgba(124,58,237,0.35)',
      }}
    >
      <span
        className="text-white font-extrabold tracking-tight relative z-10"
        style={{ fontFamily: '"Raleway", sans-serif', fontSize: Math.round(size * 0.46), lineHeight: 1 }}
      >
        N
      </span>
      <div
        className="absolute inset-0 opacity-20"
        style={{ background: 'linear-gradient(180deg, rgba(255,255,255,0.35) 0%, transparent 50%)' }}
      />
    </div>
  )
}
